// extracted by mini-css-extract-plugin
module.exports = {"article":"EncyclopediaArticle_article__1KOfx","author-contact":"EncyclopediaArticle_author-contact__Rn2CE","more-articles":"EncyclopediaArticle_more-articles__aBuX7"};